<!-- <footer>
  <div class="container">
    <div class="row footer">
      <div class="svg-icon">
        <img src="../../../assets/imgs/logoo.jpeg" style="max-width: fit-content;">
      </div>
      <div class="col-sm-3">
        <div class="logo-wrapper">
        </div>
        <br>
        <ul>
          <li>
            <h2>{{'HEADER.About' | translate}}</h2>
          </li>
          <li> <a [routerLink]="['/achievements']">{{'HEADER.ouratchivement' | translate}}</a></li>
          <li> <a [routerLink]="['/ourteam']">{{'HEADER.Ourteam' | translate}}</a></li>
          <li> <a [routerLink]="['/event']">{{'HEADER.Ourevents' | translate}}</a></li>
          <li> <a [routerLink]="['/vision']">{{'HEADER.ourvision' | translate}}</a></li>
        </ul>
      </div>

      <div class="col-sm-3">
        <ul>
          <li>
            <h2>{{'APPOINTMENT.Branch' | translate}}</h2>
          </li>
          <li class="display"> <a *ngFor="let branch of branchList" [routerLink]="['/contactus']">
              <p class="lowercase" *ngIf="currentLang == 'en'">{{branch?.name_Eng}}</p>
            </a></li>
          <li class="display"> <a *ngFor="let branch of branchList" [routerLink]="['/contactus']">
              <p *ngIf="currentLang == 'hi'">{{branch?.name_Hin}}</p>
            </a></li>
          <li class="display"> <a *ngFor="let branch of branchList" [routerLink]="['/contactus']">
              <p *ngIf="currentLang == 'mr'">{{branch?.name_Mar}}</p>
            </a></li>
        </ul>
      </div>

      <div class="col-sm-3">
        <ul>
          <li>
            <h2>{{'HEADER.menu' |
              translate}}</h2>
          </li>
          <li> <a [routerLink]="['/productlist']">{{'HEADER.Product' | translate}}</a></li>
          <li> <a [routerLink]="['/characteristics']">{{'HEADER.Characteristics' | translate}}</a></li>
          <li> <a [routerLink]="['/diseaselist']">{{'HEADER.remedies' | translate}}</a></li>
          <li> <a [routerLink]="['/whyus']" routerLinkActive="router-link-active">{{'HEADER.Contactus' |
              translate}}</a></li>
        </ul>
      </div>
      <div class="col-sm-3">
        <ul>
          <li>
            <h2> {{'HEADER.Downloadapp' |
              translate}}</h2>
          </li>
          <a _ngcontent-ggb-c322=""
            href="https://play.google.com/store/apps/details?id=com.drtodakar.drtodakar&hl=en-GB" target="_blank">
            <img class="why-img " src="../../../assets/imgs/palysore.jpg" alt="Pay store"
              style="width: 42%;text-align: center;" />
          </a>
        </ul>
        <br>
        <ul>
          <li>
            <h2> {{'HEADER.Sociallink' |
              translate}}</h2>
          </li>
          <li>
            <span class="social-icon">
              <a href="https://www.facebook.com/swagat.todkar.754" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="28.17" height="28" viewBox="0 0 28.17 28">
                  <path fill="#fff"
                    d="M28.733 14.648a14.085 14.085 0 1 0-16.286 13.915v-9.844H8.869v-4.071h3.578v-3.1c0-3.53 2.1-5.48 5.32-5.48a21.677 21.677 0 0 1 3.153.275V9.8h-1.776a2.036 2.036 0 0 0-2.3 2.2v2.644h3.906l-.625 4.072h-3.276v9.843a14.09 14.09 0 0 0 11.884-13.911z"
                    transform="translate(-.563 -.563)" />
                </svg>
              </a>
            </span>
            <span class="social-icon">
              <a href="https://www.instagram.com/swagattodkarfan/?igshid=15sprz13kw1pp" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" id="instagram_1_" width="28" height="28" viewBox="0 0 28 28">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: #fff
                      }
                    </style>
                  </defs>
                  <path id="Path_26"
                    d="M211.977 209.488a2.488 2.488 0 1 1-2.489-2.488 2.488 2.488 0 0 1 2.489 2.488zm0 0" class="cls-1"
                    transform="translate(-195.488 -195.488)" />
                  <path id="Path_27"
                    d="M147.424 137.206a2.472 2.472 0 0 0-1.417-1.417 4.13 4.13 0 0 0-1.386-.257c-.787-.036-1.023-.044-3.017-.044s-2.229.008-3.017.043a4.133 4.133 0 0 0-1.386.257 2.473 2.473 0 0 0-1.417 1.417 4.132 4.132 0 0 0-.257 1.386c-.036.787-.044 1.023-.044 3.017s.008 2.229.044 3.017a4.13 4.13 0 0 0 .257 1.386 2.472 2.472 0 0 0 1.417 1.417 4.125 4.125 0 0 0 1.386.257c.787.036 1.023.043 3.016.043s2.23-.008 3.017-.043a4.125 4.125 0 0 0 1.386-.257 2.472 2.472 0 0 0 1.417-1.417 4.134 4.134 0 0 0 .257-1.386c.036-.787.043-1.023.043-3.017s-.008-2.229-.043-3.017a4.125 4.125 0 0 0-.256-1.385zm-5.819 8.236a3.833 3.833 0 1 1 3.833-3.833 3.833 3.833 0 0 1-3.838 3.833zm3.985-6.922a.9.9 0 1 1 .9-.9.9.9 0 0 1-.901.899zm0 0"
                    class="cls-1" transform="translate(-127.605 -127.608)" />
                  <path id="Path_28"
                    d="M14 0a14 14 0 1 0 14 14A14 14 0 0 0 14 0zm7.991 17.314a5.9 5.9 0 0 1-.374 1.951 4.111 4.111 0 0 1-2.351 2.351 5.9 5.9 0 0 1-1.951.374c-.857.039-1.131.048-3.314.048s-2.457-.009-3.315-.048a5.9 5.9 0 0 1-1.951-.374 4.111 4.111 0 0 1-2.351-2.351 5.9 5.9 0 0 1-.374-1.951c-.04-.857-.049-1.131-.049-3.315s.009-2.457.048-3.314a5.9 5.9 0 0 1 .373-1.951 4.113 4.113 0 0 1 2.352-2.351 5.9 5.9 0 0 1 1.951-.374c.857-.039 1.131-.048 3.314-.048s2.457.009 3.314.049a5.9 5.9 0 0 1 1.951.373 4.112 4.112 0 0 1 2.351 2.351 5.9 5.9 0 0 1 .374 1.951c.039.857.048 1.131.048 3.314s-.007 2.458-.046 3.315zm0 0"
                    class="cls-1" />
                </svg>
              </a>
            </span>

            <span class="social-icon">
              <a href="https://www.youtube.com/channel/UC3p1NRwE4ECeeFCldxWSh5Q" target="_blank">
                <svg fill="#ffffff" height="28px" width="28px" version="1.1" id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 49 49"
                  xml:space="preserve" stroke="#ffffff">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <g>
                      <g>
                        <path
                          d="M39.256,6.5H9.744C4.371,6.5,0,10.885,0,16.274v16.451c0,5.39,4.371,9.774,9.744,9.774h29.512 c5.373,0,9.744-4.385,9.744-9.774V16.274C49,10.885,44.629,6.5,39.256,6.5z M47,32.726c0,4.287-3.474,7.774-7.744,7.774H9.744 C5.474,40.5,2,37.012,2,32.726V16.274C2,11.988,5.474,8.5,9.744,8.5h29.512c4.27,0,7.744,3.488,7.744,7.774V32.726z">
                        </path>
                        <path
                          d="M33.36,24.138l-13.855-8.115c-0.308-0.18-0.691-0.183-1.002-0.005S18,16.527,18,16.886v16.229 c0,0.358,0.192,0.69,0.502,0.868c0.154,0.088,0.326,0.132,0.498,0.132c0.175,0,0.349-0.046,0.505-0.137l13.855-8.113 c0.306-0.179,0.495-0.508,0.495-0.863S33.667,24.317,33.36,24.138z M20,31.37V18.63l10.876,6.371L20,31.37z">
                        </path>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <hr>
  <div class="container">
    <div class="copyright">
      Copyright Todkar Sanjeevani Pvt.Ltd all Rights reserved
    </div>
  </div>
</footer> --> 
 <!-- movement mater -->
<!-- <app-moment-mat></app-moment-mat> -->
<!-- fonderMSG -->


<!-- footer us section -->

<footer class="footer">
  <div class="footer-left">
    <h2>Innovative Vision</h2>
    <p>Joim Hands with Happy School and Famlies across Pune and Mumbai. A step towards Helathier, Brigher and Happier Future</p>
    <button routerLink="/program" class="btn">Explore Programs</button>
  </div>
  <div class="footer-middle">
    <!-- <h3>Contact Us</h3>  -->
    <!-- <h5 class="mb-0" style="color: #825800;">Pune Office</h5>  -->
    <img src="/src/assets/ivimg/location.svg" alt="">
    <ul>
      <h3>Contact Us</h3>
      <h4 style="color: #825800;">Pune Office:</h4>
      <li>
       <a href="#"><img src="assets/ivimg/footerSvg6.svg" alt="Girl Learning Pottery" class="img-fluid">&nbsp;
        Plot No. 5, Ground Floor, Mittal Building, &nbsp; Survey No. 48/2, Nagar Road, ChandanNagar, Pune-411014</a>
      </li>
      <li>
        <a href="#"><img src="assets/ivimg/footerSvg7.svg" alt="Girl Learning Pottery" class="img-fluid">&nbsp;(+91) 985-072-1682</a>
      </li>
      <li>
        <a href="#"><img src="assets/ivimg/footerSvg8.svg" alt="Girl Learning Pottery" class="img-fluid">&nbsp; info@innovativevision.in</a>
      </li>
    </ul>
  </div>
  <div class="footer-middle">  
    <img src="/src/assets/ivimg/location.svg" alt="">
    <ul>
      <h4 style="color: #825800;">Mumbai Office:</h4>
      <li>
        <a href="#"><img src="assets/ivimg/footerSvg6.svg" alt="Girl Learning Pottery" class="img-fluid">&nbsp;
         D54 Om Anurag CHS Opp. &nbsp; ICON Hospital Manpada Rd Dombivali East 421 201  </a>
      </li>
      <li>
        <a href="#"><img src="assets/ivimg/footerSvg7.svg" alt="Girl Learning Pottery" class="img-fluid">&nbsp;(+91) 982-046-3892</a>
      </li>
      <li>
        <a href="#"><img src="assets/ivimg/footerSvg8.svg" alt="Girl Learning Pottery" class="img-fluid">&nbsp; info@innovativevision.in</a>
      </li>
    </ul>
    <div class="footer-social">
      <a href="#"><img src="assets/ivimg/footerSvg1.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
      <a href="#"><img src="assets/ivimg/footerSvg2.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
      <a href="#"><img src="assets/ivimg/footerSvg3.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
      <a href="#"><img src="assets/ivimg/footerSvg4.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
      <a href="#"><img src="assets/ivimg/footerSvg5.svg" alt="Girl Learning Pottery" class="img-fluid"></a>
    </div>
  </div>
  <div class="footer-right">
    <h3>Quick Links</h3>
    <ul>
      <li><a routerLink="/aboutUs">About Us</a></li>
      <li><a routerLink="/program">Our Programs</a></li>
      <li><a routerLink="/event">Annual Events</a></li>
      <li><a href="#">Coaches</a></li>
      <li><a routerLink="/gallery">Gallery</a></li>
      <li><a routerLink="/mainContactUs">Contact Us</a></li>
      <li><a routerLink="/career">Career</a></li>
    </ul>
  </div>
</footer>

